import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { LangProvider } from "@/contexts/LangContext";
import { ProtectedRoute, defaultPathForRole } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import KasirPage from "@/pages/KasirPage";
import ReportsPage from "@/pages/ReportsPage";
import TherapistEarningsPage from "@/pages/TherapistEarningsPage";
import UserManagementPage from "@/pages/UserManagementPage";
import ServiceManagementPage from "@/pages/ServiceManagementPage";
import AnnouncementsPage from "@/pages/AnnouncementsPage";
import CustomersPage from "@/pages/CustomersPage";
import TherapistsReportPage from "@/pages/TherapistsReportPage";

function AppHome() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  return <Navigate to={defaultPathForRole(user.role)} replace />;
}

function ProtectedShell({ allow, children }) {
  return (
    <ProtectedRoute allow={allow}>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: { background: "#2d2d2d", border: "1px solid rgba(212,175,55,0.25)", color: "#f5f5f0" },
            }}
          />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/app" element={<AppHome />} />
            <Route path="/app/dashboard" element={<ProtectedShell allow={["admin","owner"]}><DashboardPage /></ProtectedShell>} />
            <Route path="/app/kasir" element={<ProtectedShell allow={["admin","owner","kasir"]}><KasirPage /></ProtectedShell>} />
            <Route path="/app/reports" element={<ProtectedShell allow={["admin","owner"]}><ReportsPage /></ProtectedShell>} />
            <Route path="/app/earnings" element={<ProtectedShell allow={["terapis"]}><TherapistEarningsPage /></ProtectedShell>} />
            <Route path="/app/users" element={<ProtectedShell allow={["admin"]}><UserManagementPage /></ProtectedShell>} />
            <Route path="/app/services" element={<ProtectedShell allow={["admin","owner"]}><ServiceManagementPage /></ProtectedShell>} />
            <Route path="/app/announcements" element={<ProtectedShell allow={["admin","owner"]}><AnnouncementsPage /></ProtectedShell>} />
            <Route path="/app/customers" element={<ProtectedShell allow={["admin","owner"]}><CustomersPage /></ProtectedShell>} />
            <Route path="/app/therapists-report" element={<ProtectedShell allow={["admin","owner"]}><TherapistsReportPage /></ProtectedShell>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
